import {
  RefCommunicationTemplateCreateData,
  RefCommunicationTemplateListParams,
  RefCommunicationTemplatePageResponse,
} from "@/types/refCommunicationTemplate";
import { apiUrl } from "../../utils/url";
import { HttpClient } from "../HttpClient";
import { IRefCommunicationTemplatesService } from "./IRefCommunicationTemplatesService";

export class RefCommunicationTemplatesService
  implements IRefCommunicationTemplatesService
{
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient({
      baseURL: apiUrl,
      timeout: 10000,
      headers: {},
    });
  }

  async getAll({
    page = 0,
    size = 100,
    isFollowUp,
  }: RefCommunicationTemplateListParams = {}): Promise<RefCommunicationTemplatePageResponse> {
    const queryParams = new URLSearchParams({
      page: page.toString(),
      size: size.toString(),
      sort: "id",
    });

    if (isFollowUp !== undefined) {
      queryParams.set("isFollowUp", String(isFollowUp));
    }

    try {
      return await this.httpClient.get<RefCommunicationTemplatePageResponse>(
        `/refCommunicationTemplates?${queryParams.toString()}`,
      );
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível carregar os modelos de comunicação. Atualize a página e tente novamente.",
      );
    }
  }

  async create(
    templateData: RefCommunicationTemplateCreateData,
  ): Promise<number> {
    try {
      return await this.httpClient.post<number>(
        `/refCommunicationTemplates`,
        templateData,
        {},
        true,
      );
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível criar o modelo de comunicação. Confirme os campos obrigatórios.",
      );
    }
  }

  async update(
    id: number,
    templateData: RefCommunicationTemplateCreateData,
  ): Promise<void> {
    try {
      await this.httpClient.put<void>(
        `/refCommunicationTemplates/${id}`,
        templateData,
      );
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível atualizar o modelo de comunicação. Tente guardar novamente.",
      );
    }
  }
}
